export default __webpack_public_path__ + "media/images/ico/apple-icon-60-57aa3612bf358c8cfa435358ba726efc.png";